import React from 'react'
import AppoinmentFailurePage from '../Components/AppoinmentFailure/AppoinmentFailurePage'

const AppoinmentFailureView = () => {
  return (
    <div>
        <AppoinmentFailurePage />
    </div>
  )
}

export default AppoinmentFailureView